import type { ShopDto, TaskDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import SimpleMenu from "@babackapp/ui/components/simple-menu";
import { ArrowDown, MoreVertical, RefreshCwIcon } from "lucide-react";
import { format } from "date-fns";
import { useState } from "react";
import ReplayTaskAlertDialog from "./replay-task-alert-dialog";

export default function Task(props: { task: TaskDto; shop: ShopDto }) {
  const t = useTranslation();
  const [detailOpen, setDetailOpen] = useState(false);
  const [isReplayDialogOpen, setIsReplayDialogOpen] = useState(false);

  return (
    <>
      <div className="flex text-sm space-x-4 text-gray-500 font-normal">
        <div className="">
          {format(props.task.createdAt, "yyyy-MM-dd HH:mm")}
        </div>
        <div className="flex-1">{props.task.input.file?.name}</div>
        <div>
          <TaskStatus taskStatus={props.task.status} />
        </div>
        <div className="">
          <SimpleMenu
            iconTitle={<MoreVertical className="h-4 w-4" />}
            type={"neutral"}
            menu={[
              {
                onClick: () => setIsReplayDialogOpen(true),
                title: t("settings.integrations.imports.rerun"),
                icon: <RefreshCwIcon className="h-4 w-4 mr-1 text-gray-500" />,
              },
              {
                onClick: () => {
                  setDetailOpen(true);
                },
                title: t("misc.seemore"),
                icon: <ArrowDown className="h-4 w-4 mr-1 text-gray-500" />,
              },
            ]}
          />
        </div>
      </div>

      {detailOpen && (
        <pre className="mt-1 overflow-auto rounded bg-gray-50 p-2 text-xs text-gray-600">
          {JSON.stringify(props.task.result, null, 2)}
        </pre>
      )}

      <ReplayTaskAlertDialog
        task={props.task}
        shop={props.shop}
        isOpen={isReplayDialogOpen}
        onOpenChange={setIsReplayDialogOpen}
      />
    </>
  );
}

function TaskStatus(props: { taskStatus: string }) {
  const t = useTranslation();
  if (props.taskStatus == "done") {
    return (
      <div className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
        <div className="-ml-0.5 mr-1.5 h-1.5 w-1.5 bg-green-400 rounded-full"></div>
        {t("misc.ok").toLowerCase()}
      </div>
    );
  }
  if (props.taskStatus == "error") {
    return (
      <div className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
        <div className="-ml-0.5 mr-1.5 h-1.5 w-1.5 bg-red-400 rounded-full"></div>
        {t("misc.error").toLowerCase()}
      </div>
    );
  }
  if (props.taskStatus == "running") {
    return (
      <div className="inline-flex items-center rounded-full bg-orange-100 px-2.5 py-0.5 text-xs font-medium text-orange-800">
        <div className="-ml-0.5 mr-1.5 h-1.5 w-1.5 bg-orange-400 rounded-full"></div>
        {t("misc.running").toLowerCase()}
      </div>
    );
  }
  if (props.taskStatus == "pending") {
    return (
      <div className="inline-flex items-center rounded-full bg-orange-100 px-2.5 py-0.5 text-xs font-medium text-orange-800">
        <div className="-ml-0.5 mr-1.5 h-1.5 w-1.5 bg-orange-400 rounded-full"></div>
        {t("misc.pending").toLowerCase()}
      </div>
    );
  }
  return <></>;
}
